import * as React from "react";
import {
  Modal,
  Form,
  FormControl,
  FormGroup,
  Button,
  HelpBlock,
} from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert";
import { RejectApplication } from '../../../services/ApiClient'

type RejectionApplicationFunc = ({ form_type, process_id, comment }: RejectApplication) => void;

interface State {
  show: boolean;
  form_type: string;
  comment: string;
  process_id?: number;
  rejectApplication?: RejectionApplicationFunc;
}

class RejectionModal extends React.Component<{}, State> {
  constructor() {
    super();
    this.state = {
      show: false,
      comment: "",
      form_type: "",
    };
  }

  public show(form_type: string, process_id: number, rejectApplication: RejectionApplicationFunc) {
    this.setState({
      show: true,
      form_type,
      process_id,
      rejectApplication,
    });
  }

  handleShow = () => {
    this.setState({ show: true });
  };

  handleClose = () => {
    this.setState({ show: false, comment: "" });
  };

  handleChange = (event) => {
    this.setState({ comment: event.target.value });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const length = this.state.comment.length;
    if (length >= 50 && length <= 1500) {
      this.state.rejectApplication({
        form_type: this.state.form_type,
        process_id: this.state.process_id,
        comment: event.target.comment.value,
      });

      this.handleClose();
    } else {
      confirmAlert({
        message: "Минимальная длина комментария 50 символов.",
        buttons: [
          {
            label: "Продолжить",
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onClick: () => {},
          },
        ],
      });
    }
  };

  getValidationState = () => {
    const length = this.state.comment.length;
    if (length >= 50 && length <= 1500) return "success";
    if (length > 0 && (length < 50 || length > 1500)) return "error";
    return null;
  };

  render() {
    return (
      <Modal bsSize="lg" show={this.state.show} onHide={this.handleClose}>
        <Modal.Header closeButton={true}>
          <Modal.Title>Комментарий</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={this.handleSubmit}>
            <FormGroup
              controlId="formBasicText"
              validationState={this.getValidationState()}
            >
              <FormControl
                style={{ minHeight: "200px" }}
                bsSize="lg"
                componentClass="textarea"
                placeholder="Пожалуйста, напишите причину отклонения"
                value={this.state.comment}
                onChange={this.handleChange}
                maxLength={1500}
                name="comment"
                required
              />
              <HelpBlock>Минимальная длина комментария 50 символов.</HelpBlock>
            </FormGroup>
            <Modal.Footer>
              <Button type="submit" className="btn btn-success">
                Отправить
              </Button>
              <Button onClick={this.handleClose}>Закрыть</Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

export default RejectionModal;
